/* eslint no-param-reassign: "off", no-console: "off" */
const loaderStore = {
  state: {
    dispatches: [
      { action: 'fetchMe', title: 'User Profile' }, // need this to load anything else
      { action: 'fetchSettings', title: 'User Settings' }, // settings next
      // { action: 'fetchNotifications', title: 'Notifications' }, // notifications
      { action: 'fetchAccounts', title: 'Accounts' },
      // { action: 'fetchDeviceConfigs', title: 'Device Configs' },
      // { action: 'fetchDeviceSoftwareVersions', title: 'Device Software Versions' },
      // { action: 'fetchMetricTypes', title: 'Metric Types' }
      // { action: 'fetchSharedAccounts', title: 'Shared Accounts' },
      // { action: 'fetchFavorites', title: 'Favorites' },
      // { action: 'fetchSubscriptionProducts', title: 'Subscription Products' },
      // { action: 'fetchSubscriptionPlans', title: 'Subscription Plans' }
    ],
    loadCount: 0,
    currentlyLoading: null,
    brokenRequests: []
  },
  mutations: {
    setCurrentlyLoading(state, payload) {
      state.currentlyLoading = payload;
    },
    addBrokenRequest(state, payload) {
      state.brokenRequests.push(payload);
    },
    increaseLoadCount(state) {
      state.loadCount++;
    }
  },
  actions: {
    async loadApplication({ state, commit, dispatch }) {
      // eslint-disable-next-line no-restricted-syntax
      for (const request of state.dispatches) {
        try {
          commit('setCurrentlyLoading', request.title);
          // eslint-disable-next-line no-await-in-loop
          await dispatch(request.action);
          commit('increaseLoadCount');
        } catch (ex) {
          console.error(ex);
          commit('addBrokenRequest', request);
        }
      }
      commit('setCurrentlyLoading', 'Dashboards');
      const result = await dispatch('fetchDashboards');
      if (result) await dispatch('fetchLastDashboard');
      commit('setCurrentlyLoading', null);
      return true;
    },
    async loadApplicationInBackground({ dispatch }) {
      await dispatch('fetchNotifications');
      await dispatch('fetchDeviceConfigs');
      await dispatch('fetchDeviceSoftwareVersions');
      await dispatch('fetchMetricTypes');
    }
  },
  getters: {

  }
}
export default loaderStore;
